import React, { useEffect, useState } from "react";
import useTelegram from "../hooks/telegram-hook";
import "../styles/main.css";
import "../styles/home.css";
import UserApi from "../services/api-service";
import HomeItem from "../components/home/home";
import Modal from "../components/modal/modal";
import StatusModal from "../components/modal/dialog";

function Home() {
  const tg = useTelegram();
  const { id = "1938421476" } = tg?.user || {};

  // Список домов
  const [homes, setHomes] = useState<any[]>([]);
  // Выбранный дом для покупки
  const [selectedHome, setSelectedHome] = useState<any>(null);
  // Обычный модал покупки
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Модал со статусом (успех / ошибка)
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");

  // Загружаем все дома одним запросом
  const fetchAllHomes = async () => {
    try {
      const response = await UserApi.getHomes();
      if (Array.isArray(response)) {
        setHomes(response);
      } else {
        console.error("Некорректный ответ от API getHomes()", response);
      }
    } catch (error) {
      console.error("Ошибка при загрузке домов:", error);
    }
  };

  useEffect(() => {
    fetchAllHomes();
  }, [id]);

  // Нажатие на "купить"
  const handleBuyClick = (home: any) => {
    setSelectedHome(home);
    setIsModalOpen(true);
  };

  // Подтверждение покупки
  const handleConfirm = async () => {
    if (!selectedHome) return;

    try {
      const { status, homeData } = await UserApi.buyHouse(selectedHome.id, id, selectedHome.price);

      switch (status) {
        case "success":
          const { name } = homeData;
          setStatusMessage(`Поздравляю!\nТы купил ${name}!`);
          await fetchAllHomes(); // Обновляем список домов
          break;
        case "dontMoney":
          setStatusMessage("У тебя не хватает денег на покупку этого дома.");
          break;
        case "homeBusy":
          setStatusMessage("Этот дом уже занят.");
          break;
        case "oneHomeOnly":
          setStatusMessage("Ты можешь владеть только одним домом.");
          break;
        default:
          setStatusMessage("Произошла неизвестная ошибка.");
          break;
      }
    } catch (error) {
      console.error("Ошибка при покупке дома:", error);
      setStatusMessage("Произошла ошибка при покупке дома.");
    }

    setIsModalOpen(false);
    setIsStatusModalOpen(true);
  };

  return (
    <div>
      <div className="home">
        <div className="home__container">
          <div className="home__content">
            {homes.map((home) => (
              <HomeItem
                key={home.id}
                title={home.name}
                owner={home.user ? home.user.firstname : null}
                imgSrc={`https://pablohouse.su:88${home.imgUrl}`}
                isAvailable={!home.userId}
                price={home.price}
                onBuyClick={() => handleBuyClick(home)}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Модал подтверждения покупки */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleConfirm}
        title={selectedHome?.name || ""}
        price={selectedHome?.price || 0}
      />

      {/* Модал с результатом */}
      <StatusModal
        isOpen={isStatusModalOpen}
        onClose={() => setIsStatusModalOpen(false)}
        message={statusMessage}
      />
    </div>
  );
}

export default Home;
